import { useEffect } from "react";
import FileUploader from "devextreme-react/file-uploader";
import { baseUrl, getAuthHeader } from "../modules/server";
import { logAndNotifyError, logDebugSilently } from "../modules/logger";
import Notify from "devextreme/ui/notify";
import { UploadedEvent, UploadErrorEvent } from "devextreme/ui/file_uploader";

const Upload = () => {
  const onUploadError = (e: UploadErrorEvent) => {
    logAndNotifyError(e);
    Notify(e.message, "error", 5000);
  };

  const onUploaded = (e: UploadedEvent) => {
    logDebugSilently("OnUploaded" + new Date());
    try {
      const result = JSON.parse(e.request.response);
      if (result.success) {
        Notify(result.message, "success", 5000);
        PubSub.publish("NewDataFile");
      } else {
        Notify(result.message, "error", 5000);
      }
    } catch (err) {
      logAndNotifyError(err);
    }
  };

  return (
    <>
      <h2>Ladda upp data via Excel-fil</h2>
      <div>
        <FileUploader
          name="file"
          accept=".xlsx"
          allowedFileExtensions={[".xlsx"]}
          uploadHeaders={getAuthHeader()}
          uploadMode="instantly"
          uploadUrl={baseUrl + "UploadFile/"}
          onUploadError={onUploadError}
          onUploaded={onUploaded}
          multiple={false}
          maxFileSize={10000000}
        />
      </div>
    </>
  );
};

export default Upload;
